<dialog class="modal-base" (click)="backdropClick($event)" (close)="close()" #dialog>
    <div class="modal-base__content">
        @if (!hideCloseButton()) {
            <stby-modal-close-button (clicked)="requestClose()" />
        }
        <ng-content />
    </div>
</dialog>
